import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CreditNoteStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('CreditNoteStatusReference');
  }
}
